module.exports = __webpack_public_path__ + "static/media/automation-controller-icon.c4f1da0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/automation-controller-icon.svg
// module id = ./src/assets/images/automation-controller-icon.svg
// module chunks = 0